<script>
import Product from '@phoenix/mixins/components/common/Product';
import ProductCardTags from '@maison/components/product/ProductCardTags';
import WishlistButton from '@maison/components/wishlist/WishlistButton';
import PhxPicture from '@maison/components/common/PhxPicture.vue';

export default {
  components: {
    PhxPicture,
    ProductCardTags,
    WishlistButton,
  },

  mixins: [Product],

  props: {
    defaultInWishlistIcon: {
      type: String,
      default: 'heart-full',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    labelsNamedPagesUrls: {
      type: Object,
      default: () => ({}),
    },
    isDiscontinuedReference: {
      type: Boolean,
      default: false,
    },
    displayClasses: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    productClasses() {
      return ['product-card'].concat(this.displayClasses);
    },
  },
};
</script>

<template>
  <div :class="productClasses">
    <div class="picture product-card__picture picture--contain">
      <PhxPicture v-bind="image" class="phx-picture-variant" />
    </div>
    <div class="product-card__description">
      <a
        :href="url"
        :data-tracking="dataTracking ? JSON.stringify(dataTracking) : null"
        class="product-card__link expand-target"
      >
        <div class="product-card__name" dir="ltr">{{ name }}</div>
        <div class="product-card__collection">{{ description }}</div>
        <div class="product-card__ref" dir="ltr">{{ internalReference }}</div>
        <div class="product-price product-price--small">
          <template v-if="isDiscontinuedReference">
            <span class="product-price__value">{{ $t('Product.discontinuedReference.label') }}</span>
          </template>
          <template v-else>
            <product-price
              class="product-price__value"
              v-bind="localizedPrice"
              :should-display-from-price="shouldDisplayFromPrice"
            />
            <span v-if="shouldDisplayVatInformation" class="product-price__vat">{{ vatInformation }}</span>
          </template>
        </div>
      </a>
      <product-card-tags :labels="labels" :labels-named-pages-urls="labelsNamedPagesUrls" should-display />
    </div>
    <ul v-if="shouldDisplayAddToWishlist" role="presentation" class="product-card__actions">
      <li role="presentation">
        <wishlist-button
          :reference="modelReference"
          :internal-reference="internalReference"
          :name="name"
          :default-in-wishlist-icon="defaultInWishlistIcon"
          :tracking="tracking"
        />
      </li>
    </ul>
  </div>
</template>
